import React from 'react';
import { twMerge } from 'tailwind-merge';
interface PulseBadgeProps {
  children: React.ReactNode;
  className?: string;
}

const PulseBadge = ({ children, className }: PulseBadgeProps) => {
  return (
    <span
      className={twMerge(
        'px-1.5 py-0.5 text-sm rounded-full whitespace-nowrap  text-neutral-700 ',
        className
      )}
    >
      {children}
    </span>
  );
};

export default PulseBadge;
